/* eslint-disable react/destructuring-assignment */
import 'common/i18next';
import 'ka-table/style.css';

import {createInstance, MatomoProvider} from '@datapunt/matomo-tracker-react';
import {CssBaseline} from '@mui/material';
import {StyledEngineProvider} from '@mui/material/styles';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import Compose from 'common/components/Compose';
import {FROV_SIGN} from 'common/constants';
import getTheme from 'common/theme/getTheme';
import {EFrovSign} from 'common/types';
import Cookies from 'js-cookie';
import {AuthProvider} from 'modules/auth/auth.context';
import {FeatureToggleProvider} from 'modules/FeatureToggle';
import {RefetchProvider} from 'modules';
import {SnackbarProvider} from 'notistack';
import React from 'react';
import Router from 'routes/Router';
import {ThemeProvider} from 'styled-components';

// eslint-disable-next-line react-refresh/only-export-components
export const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 10,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      // cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const matomoInstance = createInstance({
  urlBase: 'https://matomo.x5.ru/',
  siteId: 23,
  trackerUrl: 'https://matomo.x5.ru/matomo.php', // optional, default value: `${urlBase}matomo.php`
  srcUrl: 'https://matomo.x5.ru/matomo.js', // optional, default value: `${urlBase}matomo.js`
  linkTracking: false, // Important!
  configurations: {
    setRequestMethod: 'POST',
  },
});
const frovsign = Cookies.get(FROV_SIGN);
const theme = getTheme(frovsign as EFrovSign);

const providers = [
  [AuthProvider],
  [QueryClientProvider, {client}],
  [MatomoProvider, {value: matomoInstance}],
  [StyledEngineProvider, {injectFirst: true}],
  [ThemeProvider, {theme}],
  [SnackbarProvider, {maxSnack: 3}],
  [FeatureToggleProvider],
  [RefetchProvider],
];

const App: React.FC = () => {
  return (
    <Compose components={providers}>
      <CssBaseline />
      <Router />
      <ReactQueryDevtools initialIsOpen />
    </Compose>
  );
};

export default App;
